import React from 'react';

import styled from '@emotion/styled';
import { Form as AForm, FormItemProps } from 'antd';

const { Item: AFormItem, Provider: AProvider } = AForm;

interface TFormItemParams extends FormItemProps {}

export const Form = styled(AForm)``;

export const FormProvider = styled(AProvider)``;

const StyledFormItem = styled(AFormItem)`
  margin: 0 !important;

  .ant-form-item-label {
    min-width: 175px !important;
    padding: 10px 21px;
    background: ${({ theme }) => theme.gray2};
    border-right: 1px solid ${({ theme }) => theme.gray3};
  }

  .ant-form-item-label > label {
    display: inline-flex;
    vertical-align: top;
    width: 100%;
  }

  .ant-form-item-label > label::after {
    content: none;
  }

  .ant-form-item-explain.ant-form-item-explain-error > div {
    padding-top: 2px !important;
  }

  .ant-form-item-control {
    /* padding: 10px 21px; */
  }
  .ant-input {
    font-size: 14px;
  }
  .ant-form-item-children-icon {
    line-height: 23px !important;
  }
`;

export const FormItem = ({ ...rest }: TFormItemParams) => <StyledFormItem {...rest} />;

export const DetailItem = styled(FormItem)`
  > .ant-form-item-control {
    min-height: 50px;
    padding-top: 10px;
    padding-left: 20px;
  }
`;
